import { addMessages } from '@hana/i18n';

// Khoá chuỗi của Cài đặt cá nhân (Settings · Compact). Mã ghế, tên riêng và dữ liệu mẫu không dịch.
addMessages('vi', {
  'sys.acct': '{mail} · tài khoản Microsoft 365',
  'sys.openMee': 'Mở HANA Mee ↗',
  'sys.changePhoto': 'Đổi ảnh',
  'sys.seatsHeld': 'Ghế đang giữ',
  'sys.working': 'Đang làm việc',
  'sys.workSeat': 'Làm việc với ghế này',
  'sys.requestPlus': 'Xin cấp',
  'sys.turns412': '412 lượt',
  'sys.viewDetail': 'Xem chi tiết',
  'sys.plusNote': 'Ask HANA+ dùng model mạnh hơn: Admin IT cấp theo người và theo chức năng. Hạn mức lượt hỏi Hana+ mỗi tháng: chờ anh chốt.',
  'sys.addPasskey': 'Thêm passkey',
  'sys.remove': 'Gỡ',
  'sys.lockScreen': 'Khoá màn',
  'sys.openMs': 'Mở tài khoản Microsoft',
  'sys.openFiles': 'Mở My Files',
  'sys.openCustoms': 'Mở Customs Data',
  'sys.sendFeedback': 'Gửi góp ý',
  'sys.viewThread': 'Xem trao đổi',
  'sys.assignedToMe': 'Giao cho tôi',
  'sys.type': 'Loại',
  'sys.regDevice': 'Đăng ký máy này',
  'sys.sendTest': 'Gửi thử',
  'sys.backupBySeat': 'Backup của tôi theo ghế',
  'sys.delegActive': 'Uỷ quyền đang hiệu lực',
  'sys.absentToday': 'Vắng hôm nay',
  'sys.delegate': 'Uỷ quyền',
  'sys.noDeleg': 'Chưa có uỷ quyền nào.',
  'sys.end': 'Kết thúc',
  'sys.sessionsHd': 'Phiên đăng nhập & thiết bị',
  'sys.signOutAll': 'Đăng xuất mọi máy khác',
  'sys.thisDevice': 'Máy này',
  'sys.clockReg': 'Đã đăng ký chấm công',
  'sys.signOut': 'Đăng xuất',
  'sys.printKeys': 'In bảng phím tắt (PDF)',
  'sys.retry': 'Thử lại',
  'sys.cancel': 'Huỷ',
  'sys.seat': 'Ghế',
  'sys.recipient': 'Người nhận',
  'sys.pickPerson': 'Chọn người…',
  'sys.pickRecipient': 'Chọn người nhận',
  'sys.keep': 'Giữ',
  'sys.cSelfAppr': 'Việc anh vừa đề nghị vừa duyệt ở cấp BOD ghi cờ "Tự duyệt" trong báo cáo kiểm soát tháng.',
  'sys.cP0': 'Khẩn P0 luôn gửi push + Zalo song song từ phút 0, không tắt được trong app.',
  'sys.cAbsent': 'Phiếu chờ anh duyệt trong kỳ vắng tự chuyển lên cấp trên — không giao cho đồng cấp.',
  'sys.cClockOut': 'Đăng xuất thiết bị chấm công thì đăng ký lại cần HR duyệt.',
});
addMessages('en', {
  'sys.acct': "{mail} · Microsoft 365 account",
  'sys.openMee': "Open HANA Mee ↗",
  'sys.changePhoto': "Change photo",
  'sys.seatsHeld': "Seats held",
  'sys.working': "Working",
  'sys.workSeat': "Work with this seat",
  'sys.requestPlus': "Request",
  'sys.turns412': "412 queries",
  'sys.viewDetail': "View details",
  'sys.plusNote': "Ask HANA+ uses a stronger model: IT Admin grants it per person and per feature. Monthly Hana+ query quota: pending decision.",
  'sys.addPasskey': "Add passkey",
  'sys.remove': "Remove",
  'sys.lockScreen': "Lock screen",
  'sys.openMs': "Open Microsoft account",
  'sys.openFiles': "Open My Files",
  'sys.openCustoms': "Open Customs Data",
  'sys.sendFeedback': "Send feedback",
  'sys.viewThread': "View conversation",
  'sys.assignedToMe': "Assigned to me",
  'sys.type': "Type",
  'sys.regDevice': "Register this device",
  'sys.sendTest': "Send test",
  'sys.backupBySeat': "My backups by seat",
  'sys.delegActive': "Active delegations",
  'sys.absentToday': "Absent today",
  'sys.delegate': "Delegate",
  'sys.noDeleg': "No delegations yet.",
  'sys.end': "End",
  'sys.sessionsHd': "Sessions & devices",
  'sys.signOutAll': "Sign out all other devices",
  'sys.thisDevice': "This device",
  'sys.clockReg': "Registered for timekeeping",
  'sys.signOut': "Sign out",
  'sys.printKeys': "Print shortcuts (PDF)",
  'sys.retry': "Retry",
  'sys.cancel': "Cancel",
  'sys.seat': "Seat",
  'sys.recipient': "Recipient",
  'sys.pickPerson': "Pick a person…",
  'sys.pickRecipient': "Pick a recipient",
  'sys.keep': "Keep",
  'sys.cSelfAppr': "Items you both request and approve at BOD level are flagged \"Self-approved\" in the monthly control report.",
  'sys.cP0': "P0 urgent always sends push + Zalo in parallel from minute 0 and cannot be turned off in the app.",
  'sys.cAbsent': "Approvals pending on you during an absence go to the next level up — never to a peer.",
  'sys.cClockOut': "Signing out a timekeeping device means re-registering needs HR approval.",
});
